import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";

class MoneyRepositoryList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        let {view, componentConfig, filter, selection, isLoading, columnSort} = this.props;
        if (!filter) {
            filter = [];
        }
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "MoneyRepositoryList"}
                {...props}
                columnSort={columnSort}
                exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                columns={{
                    [componentConfig.idfield]: {
                        header: 'Kód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "name": {
                        header: 'Név',
                        width: 6,
                        sortable,
                        filterable
                    },
                    "location.name": {
                        header: 'Helyszín',
                        width: 4,
                        sortable,
                        filterable
                    }
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default MoneyRepositoryList;
